/* eslint-disable no-plusplus */
import React, { useRef, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';

import getValidationErrors from '../../../utils/getValidationErrors';

import { Container, Content, ContentArea, FormContainer } from './styles';

import api from '../../../services/api';

import UtilMenu from '../../../components/UtilMenu';
import InputWithLabel from '../../../components/InputWithLabel';
import Button from '../../../components/Button';

interface UserFormData {
  name: string;
  email: string;
  password: string;
}

interface Location {
  id: string;
  name: string;
  email: string;
  password: string;
}

const UserForm: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const locationState: Location = location.state as Location;

  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  useEffect(() => {
    if (locationState) {
      formRef.current?.setData({ name: locationState.name });
    }
  }, [locationState]);

  const handleSubmit = useCallback(
    async (data: UserFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
          password: Yup.string().min(6, 'Mínimo de 6 dígitos'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (!locationState) {
          await api.post('/users', data);
        } else {
          await api.put('/users', {
            id: locationState.id,
            name: data.name,
          });
        }

        history.push('/user');

        addToast({
          type: 'success',
          title: !locationState ? 'Cadastro realizado!' : 'Cadastro alterado',
          description: !locationState
            ? 'Novo usuário criado'
            : 'Usuário alterado',
        });
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Ocorreu um erro ao cadastrar usuário.',
        });
      }
    },
    [addToast, history, locationState],
  );

  return (
    <Container>
      <Content>
        <UtilMenu />
        <ContentArea>
          <h1>Cadastro de Usuário</h1>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <FormContainer>
              <InputWithLabel name="name" label="Nome" />
            </FormContainer>

            <FormContainer>
              <InputWithLabel name="email" label="E-mail" />
            </FormContainer>

            <FormContainer>
              <InputWithLabel name="password" type="password" label="Senha" />
            </FormContainer>

            <Button type="submit">Salvar</Button>
          </Form>
        </ContentArea>
      </Content>
    </Container>
  );
};

export default UserForm;
